<template>
<div id="app" class="site container hfeed" style="height: auto !important;">
  <HeadNav selectedLanguage="en" page="about" />
  <div id="content" class="site-content" style="height: auto !important">
    <article id="article" class="center" style="height: auto !important">
      <section class="page-content">
        <h1>About GBWhatsApp</h1>
        <p>Welcome to GBWhatsApp, your trusted source for downloading the latest WhatsApp modifications.</p>
        
        <h2>Our Mission</h2>
        <p>We are dedicated to providing users with the best WhatsApp mod experience, offering detailed information, installation guides, and the latest APK downloads for popular WhatsApp modifications including GBWhatsApp, FMWhatsApp, YoWhatsApp, and many more.</p>
        
        <h2>What We Offer</h2>
        <ul>
          <li>Latest APK downloads for all major WhatsApp mods</li>
          <li>Comprehensive installation guides</li>
          <li>Detailed feature comparisons</li>
          <li>Regular updates on new versions</li>
          <li>Safety and security information</li>
        </ul>
        
        <h2>Why Choose Us</h2>
        <p>We provide verified downloads, detailed reviews, and comprehensive guides to help you get the most out of your WhatsApp experience. Our team regularly updates our content to ensure you have the latest information about all WhatsApp modifications.</p>
        
        <h2>Contact Us</h2>
        <p>If you have any questions or suggestions, please feel free to contact us through our contact page.</p>
      </section>
    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'About',
  components: {
    HeadNav,
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  max-width: 1080px;
  margin: 2rem auto;
  padding: 40px 20px;
  background: #fff;
  border-radius: 12px;
  
  h1 {
    color: #25D366;
    font-size: 2.5em;
    margin-bottom: 30px;
    text-align: center;
  }
  
  h2 {
    color: #25D366;
    font-size: 1.8em;
    margin: 30px 0 20px;
  }
  
  p {
    line-height: 1.8;
    font-size: 16px;
    color: #444;
    margin-bottom: 15px;
    text-align: left;
  }
  
  ul {
    list-style: none;
    padding: 0;
    text-align: left;
    
    li {
      padding: 10px 0 10px 20px;
      position: relative;
      line-height: 1.6;
      
      &::before {
        content: "✓";
        position: absolute;
        left: 0;
        color: #25D366;
      }
    }
  }
}

@media (max-width: 768px) {
  .page-content {
    padding: 20px 15px;
    
    h1 { font-size: 2em; }
    h2 { font-size: 1.5em; }
  }
}
</style>
